export default __webpack_public_path__ + "static/media/vbb-in-action.03c629ff.png";